<template>
  <v-overlay :value="isActive" style="z-index:9999">
    <v-card height="120" width="120" align="center" justify="center">
      <v-card-text class="pt-8">
        <v-progress-circular indeterminate size="56"></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  name: "wtk-loading",
  data: () => ({}),
  computed: {
    isActive: {
      get() {
        return this.$store.getters["message/loading"].isActive;
      },
      set(val) {
        this.options.isActive = val;
        this.$store.dispatch("message/options", this.options);
      },
    },
    options() {
      return this.$store.getters["message/loading"].options;
    },
  },
};
</script>